import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import FormEditor from './FormEditor.vue';
import FormSubmissions from './FormSubmissions.vue';

const meta = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/forms'),
      component: SettingsWrapper,
      children: [
        { path: '', name: 'forms_settings_index', meta, component: Index },
        {
          path: 'new',
          name: 'forms_settings_new',
          meta,
          component: FormEditor,
        },
        {
          path: ':formId',
          name: 'forms_settings_edit',
          meta,
          component: FormEditor,
          props: true,
        },
        {
          path: ':formId/submissions',
          name: 'forms_settings_submissions',
          meta,
          component: FormSubmissions,
          props: true,
        },
      ],
    },
  ],
};
